import { z } from "zod";

export const guestEmailUpdateAndResendInputZodSchema = z.object({
	guestEmail: z.string().email({ message: "正しいメールの形式ではありません" }),
});

export type GuestEmailUpdateAndResendInputType = z.infer<typeof guestEmailUpdateAndResendInputZodSchema>;
